import React, { useState, useEffect, useRef, useMemo } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    ScrollableContent,
    ActionSection,
    ModalHeader,
    RupeeIcon,
} from "../Styles/InputStyles";
import { MdClose, MdEdit } from "react-icons/md";
import tw from "tailwind-styled-components";
import SelectOptionModal from "../SelectOptionModal";
import { tranfer_payment_method } from "../../Config";
import SelectItemModal from "../SelectItemModal";
import { Tabs, Tab, Box } from "@mui/material";
import CategoryCard from "../CategoryCard";
import SelectCategoryModal from "../Expenses/SelectCategoryModal";
import ConfirmModal from "../Common/ConfirmModal";
import VerifyBankAccount from "../Common/VerfiyBankAccount";
import moment from "moment";

const AddTransferDetail = ({
    addTransferAccountMutate,
    addTransferAccountLoading,
    handleClose,
    beneficiariesData,
    expCategories,
    availableAmount = 300,
    verifyBankAccount,
    verifyAccountLoading,
    isAccountVerified,
    verifiedAccountName,
    //setVerifiedAccountName,
    verifyErrorMsg,
    clearVerification,
    maxTransLimit
}) => {
    //const [isAccountVerified, setIsAccountVerified] = useState(false);
    //const [verifiedAccountName, setVerifiedAccountName] = useState("");
    const [showConfirmTransferModal, setShowConfirmTransferModal] = useState(false);
    const [pendingPayload, setPendingPayload] = useState(null);

    const categories = useMemo(() => {
        return expCategories?.map((section) => ({
            type: "group",
            name: section.name,
            items: section.items.map((item) => ({
                value: item.id + "",
                label: item.name,
            })),
        }));
    }, [expCategories]);

    const initialValues = {
        beneficiaryId: "",
        beneficiaryName: "",
        mobile: "",
        amount: "",
        method: "",
        remarks: "",
        // Bank account fields
        accountName: "",
        accountNumber: "",
        ifsc: "",
        category: "",
        mobileNo: '',
        deductChargesFromVendor: false
    };

    const [height, setHeight] = useState(window.innerHeight);
    const [isMethodModalOpen, setIsMethodModalOpen] = useState(false);
    const [sBeneficaryModalOpen, setIsBeneficaryModalOpen] = useState(false);
    const [selectedBeneficary, setSelectedBeneficary] = useState(null);
    const [remarksLength, setRemarksLength] = useState(0);
    const [showCategoryModal, setShowCategoryModal] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState(null)

    const [activeTab, setActiveTab] = useState(0);
    const formikRef = useRef(null);

    const beneficiary = beneficiariesData;

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const transferMethodOptions = tranfer_payment_method.map((method) => ({
        label: method.label,
        value: method.value,
    }));

    // Yup Validation Schema for Beneficiary Tab
    const beneficiaryValidationSchema = Yup.object({
        beneficiaryId: Yup.string()
            .required("Please select a beneficiary"),
        beneficiaryName: Yup.string()
            .required("Name is required"),
        amount: Yup.number()
            .required("Amount is required")
            .positive("Amount must be greater than 0")
            .max(
                500000,
                "Amount cannot exceed ₹5,00,000"
            )
            .test(
                "available-balance",
                `Amount cannot exceed available balance of ₹${Number(
                    availableAmount || 0
                ).toLocaleString("en-IN")}`,
                function (value) {
                    return Number(value || 0) <= Number(availableAmount || 0);
                }
            )
            .test(
                "max-transaction-limit",
                `Amount cannot exceed your maximum transaction limit of ₹${Number(
                    maxTransLimit || 0
                ).toLocaleString("en-IN")}`,
                function (value) {
                    // No maximum transaction limit configured
                    if (Number(maxTransLimit || 0) <= 0) {
                        return true;
                    }

                    return Number(value || 0) <= Number(maxTransLimit);
                }
            )
            .when("method", {
                is: 3, // RTGS
                then: (schema) =>
                    schema.min(
                        200000,
                        "Minimum amount for RTGS is ₹2,00,000"
                    ),
            })
            .typeError("Amount must be a valid number"),
        method: Yup.number()
            .required("Please select a transfer method"),
        category: Yup.string()
            .required("Please select category"),
        remarks: Yup.string()
            .max(500, "Remarks cannot exceed 500 characters")
            .nullable()
    });

    // Yup Validation Schema for Bank Tab
    const bankValidationSchema = Yup.object({
        mobileNo: Yup.string()
            .required("Mobile number is required")
            .matches(/^[0-9]+$/, "Mobile number must contain only numbers")
            .length(10, "Mobile number must be exactly 10 digits"),
        accountName: Yup.string()
            .required("Account holder name is required")
            .matches(
                /^[A-Za-z0-9. ]+$/,
                "Account holder name can only contain letters, numbers, spaces & dots"
            )
            .min(4, "Account holder name must be at least 4 characters long")
            .max(100, "Account holder name cannot exceed 100 characters"),
        accountNumber: Yup.string()
            .required("Account number is required")
            .matches(/^[0-9]{9,18}$/, "Account number must be 9-18 digits"),
        ifsc: Yup.string()
            .required("IFSC code is required")
            .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code format"),
        amount: Yup.number()
            .required("Amount is required")
            .positive("Amount must be greater than 0")
            .max(
                500000,
                "Amount cannot exceed ₹5,00,000"
            )
            .test(
                "available-balance",
                `Amount cannot exceed available balance of ₹${Number(
                    availableAmount || 0
                ).toLocaleString("en-IN")}`,
                function (value) {
                    return Number(value || 0) <= Number(availableAmount || 0);
                }
            )
            .test(
                "max-transaction-limit",
                `Amount cannot exceed your maximum transaction limit of ₹${Number(
                    maxTransLimit || 0
                ).toLocaleString("en-IN")}`,
                function (value) {
                    // No maximum transaction limit configured
                    if (Number(maxTransLimit || 0) <= 0) {
                        return true;
                    }

                    return Number(value || 0) <= Number(maxTransLimit);
                }
            )
            .when("method", {
                is: 3, // RTGS
                then: (schema) =>
                    schema.min(
                        200000,
                        "Minimum amount for RTGS is ₹2,00,000"
                    ),
            })
            .typeError("Amount must be a valid number"),
        method: Yup.number()
            .required("Please select a transfer method"),
        category: Yup.string()
            .required("Please select category"),
        remarks: Yup.string()
            .max(500, "Remarks cannot exceed 500 characters")
            .nullable()
    });

    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        let payload;
        if (activeTab === 0) {
            // Beneficiary A/C
            payload = {
                beneficiaryId: values.beneficiaryId,
                beneficiaryName: values.beneficiaryName,
                mobile: values.mobile,
                amount: Number(values.amount),
                method: values.method,
                id: values.id,
                remarks: values.remarks || "",
                expenseType: values.category,
                type: "beneficiary",
                currentBalance: availableAmount,
                deductChargesFromVendor: values.deductChargesFromVendor ? 1 : 0,
            };
        } else {
            // Bank A/C
            payload = {
                mobile: values.mobileNo,
                accountName: values.accountName,
                accountNumber: values.accountNumber,
                ifsc: values.ifsc,
                amount: Number(values.amount),
                method: values.method,
                remarks: values.remarks || "",
                expenseType: values.category,
                type: "bank",
                currentBalance: availableAmount,
                deductChargesFromVendor: values.deductChargesFromVendor ? 1 : 0,
            };
        }
        //addTransferAccountMutate(payload);
        setPendingPayload(payload);
        setShowConfirmTransferModal(true);
    };

    const getCurrentMethodLabel = (methodValue) => {
        const selectedMethod = tranfer_payment_method.find(
            (method) => method.value === methodValue
        );
        return selectedMethod ? selectedMethod.label : "Select transfer method";
    };

    const handleBeneficiarySelect = (beneficiary) => {
        if (beneficiary && formikRef.current) {
            formikRef.current.setFieldValue("beneficiaryId", beneficiary.cfBeneficiaryId);
            formikRef.current.setFieldValue("beneficiaryName", beneficiary.name || "");
            formikRef.current.setFieldValue("id", beneficiary.id || "");
            formikRef.current.setFieldValue("mobile", beneficiary.mobile || "");
            setSelectedBeneficary(beneficiary);
        } else if (formikRef.current) {
            formikRef.current.setFieldValue("beneficiaryId", "");
            formikRef.current.setFieldValue("beneficiaryName", "");
            formikRef.current.setFieldValue("id", "");
            formikRef.current.setFieldValue("mobile", "");
            setSelectedBeneficary(null);
        }
        setIsBeneficaryModalOpen(false);
    };

    const getSelectedBeneficiaryDisplay = () => {
        if (selectedBeneficary) {
            return {
                label: selectedBeneficary.name,
                value: selectedBeneficary.cfBeneficiaryId,
                subtitle: selectedBeneficary.mobile
            };
        }
        return null;
    };

    const handleRemarksChange = (e, setFieldValue) => {
        const value = e.target.value;
        if (value.length <= 500) {
            setFieldValue("remarks", value);
            setRemarksLength(value.length);
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        // Reset form fields when switching tabs
        if (formikRef.current) {
            if (newValue === 0) {
                formikRef.current.setFieldValue("accountName", "");
                formikRef.current.setFieldValue("accountNumber", "");
                formikRef.current.setFieldValue("ifsc", "");
                formikRef.current.setFieldValue("mobileNo", "");
                clearVerification();
            } else {
                formikRef.current.setFieldValue("beneficiaryId", "");
                formikRef.current.setFieldValue("beneficiaryName", "");
                formikRef.current.setFieldValue("mobile", "");
                formikRef.current.setFieldValue("id", "");
                setSelectedBeneficary(null);
            }
            // Clear common fields
            formikRef.current.setFieldValue("amount", "");
            formikRef.current.setFieldValue("method", "");
            formikRef.current.setFieldValue("remarks", "");
            setRemarksLength(0);
        }
    };

    const handleSelectedCategory = (selectedOption) => {
        setSelectedCategory(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("category", selectedOption.value)
        }
    }

    const handleCategorySave = (category) => {
        handleSelectedCategory(category)
        setShowCategoryModal(false)
    }

    return (
        <Container
            style={{
                height: `${height}px`,
                overflow: "auto",
                WebkitOverflowScrolling: "touch",
            }}
        >
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Make Payout</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontSize: '14px',
                            minWidth: 'auto',
                            px: 2,
                        },
                        '& .Mui-selected': {
                            color: '#0078BD !important',
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#0078BD',
                        }
                    }}
                >
                    <Tab label="Transfer to Beneficiary" />
                    <Tab label="Quick Transfer" />
                </Tabs>
            </Box>
            <div className="custom-scrollbar px-6 h-full flex flex-col justify-between">
                <Formik
                    innerRef={formikRef}
                    initialValues={initialValues}
                    validationSchema={activeTab === 0 ? beneficiaryValidationSchema : bankValidationSchema}
                    onSubmit={handleSubmit}
                    validateOnChange={true}
                    validateOnBlur={true}
                >
                    {({ values, setFieldValue, errors, touched, isSubmitting, handleChange, handleBlur }) => {
                        const handleMethodSelect = (selectedValue) => {
                            setFieldValue("method", selectedValue);
                        };

                        return (
                            <Form>
                                <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                    <Wrapper>
                                        {activeTab === 0 ? (
                                            // Beneficiary A/C Fields
                                            <InputGroup>
                                                <Label htmlFor="beneficiaryName">Select Beneficiary *</Label>
                                                <CategoryCard
                                                    title="Beneficiary Name"
                                                    selectedCategory={getSelectedBeneficiaryDisplay()}
                                                    onClick={() => setIsBeneficaryModalOpen(true)}
                                                />

                                                {errors.beneficiaryId && touched.beneficiaryId && (
                                                    <ErrorText>{errors.beneficiaryId}</ErrorText>
                                                )}
                                                {selectedBeneficary &&
                                                    <div className="mt-2 flex flex-wrap gap-2">
                                                        {/* Account Number */}
                                                        <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">
                                                            🏦 ••••{selectedBeneficary.accountNum?.slice(-4)}
                                                        </span>

                                                        {/* IFSC */}
                                                        <span className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">
                                                            {selectedBeneficary?.ifsc || '0000'}
                                                        </span>

                                                        {/* Last Payment */}
                                                        {selectedBeneficary?.lastPaidDate && (
                                                            <>
                                                                <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-medium text-blue-700">
                                                                    ₹{Number(selectedBeneficary.lastPaidAmount || 0)} •{" "}
                                                                    {moment(selectedBeneficary.lastPaidDate).format("DD MMM, YY")}
                                                                </span>

                                                                {/* Payment Source */}
                                                                <span
                                                                    className={`rounded-full px-3 py-1 text-xs font-medium ${selectedBeneficary.isLastPaymentOnline
                                                                        ? "bg-green-50 text-green-700"
                                                                        : "bg-amber-50 text-amber-700"
                                                                        }`}
                                                                >
                                                                    {selectedBeneficary.isLastPaymentOnline ? "🟢 Kipinn" : "🟠 Offline"}
                                                                </span>
                                                            </>
                                                        )}
                                                    </div>
                                                }
                                            </InputGroup>

                                        ) : (
                                            // Bank A/C Fields - Simple Inputs
                                            <>
                                                <InputGroup>
                                                    <Label htmlFor="mobileNo">Mobile Number *</Label>
                                                    <FieldWrappers className={errors.mobileNo && touched.mobileNo ? "border-red-500" : ""}>
                                                        <Field
                                                            type="text"
                                                            name="mobileNo"
                                                            id="mobileNo"
                                                            autoComplete="off"
                                                            maxLength="10"
                                                            placeholder="Enter mobile number"
                                                        />
                                                    </FieldWrappers>
                                                    {errors.mobileNo && touched.mobileNo && (
                                                        <ErrorText>{errors.mobileNo}</ErrorText>
                                                    )}

                                                </InputGroup>
                                                <InputGroup>
                                                    <Label htmlFor="accountName">Account Holder Name *</Label>
                                                    <FieldWrappers>
                                                        <Field
                                                            type="text"
                                                            name="accountName"
                                                            id="accountName"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.accountName}
                                                            placeholder="Enter account name"
                                                            className={errors.accountName && touched.accountName ? "border-red-500" : ""}
                                                        />
                                                        {isAccountVerified &&
                                                            values.accountName?.trim().toLowerCase() ===
                                                            verifiedAccountName?.trim().toLowerCase() && (
                                                                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-green-600 text-xs font-medium">
                                                                    ✓ Verified
                                                                </span>
                                                            )}
                                                    </FieldWrappers>
                                                    {errors.accountName && touched.accountName && (
                                                        <ErrorText>{errors.accountName}</ErrorText>
                                                    )}
                                                    {isAccountVerified &&
                                                        values.accountName?.trim().toLowerCase() !==
                                                        verifiedAccountName?.trim().toLowerCase() && (
                                                            <div className="mt-2 rounded-lg border border-yellow-200 bg-yellow-50 p-3">
                                                                <div className="flex items-center justify-between">
                                                                    <div>
                                                                        <p className="text-sm font-medium text-yellow-800">
                                                                            Name Mismatch
                                                                        </p>

                                                                        <p className="text-xs text-yellow-700 mt-1">
                                                                            Bank account holder name:{" "}
                                                                            <span className="font-semibold">
                                                                                {verifiedAccountName}
                                                                            </span>
                                                                        </p>
                                                                    </div>

                                                                    <button
                                                                        type="button"
                                                                        className="text-xs font-semibold text-cblue-default hover:underline"
                                                                        onClick={() => {
                                                                            setFieldValue(
                                                                                "accountName",
                                                                                verifiedAccountName,
                                                                            );
                                                                            //setVerifiedAccountName ('');
                                                                        }
                                                                        }
                                                                    >
                                                                        Use Verified Name
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )}

                                                </InputGroup>

                                                <InputGroup>
                                                    <Label htmlFor="accountNumber">Account Number *</Label>
                                                    <FieldWrappers>
                                                        <Field
                                                            type="text"
                                                            name="accountNumber"
                                                            id="accountNumber"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.accountNumber}
                                                            placeholder="Enter account number"
                                                            className={errors.accountNumber && touched.accountNumber ? "border-red-500" : ""}
                                                        />
                                                    </FieldWrappers>
                                                    {errors.accountNumber && touched.accountNumber && (
                                                        <ErrorText>{errors.accountNumber}</ErrorText>
                                                    )}
                                                </InputGroup>

                                                <InputGroup>
                                                    <Label htmlFor="ifsc">IFSC *</Label>
                                                    <FieldWrappers>
                                                        <Field
                                                            type="text"
                                                            name="ifsc"
                                                            id="ifsc"
                                                            onChange={(e) => {
                                                                setFieldValue("ifsc", e.target.value.toUpperCase());
                                                            }}
                                                            onBlur={handleBlur}
                                                            value={values.ifsc}
                                                            placeholder="Enter IFSC code"
                                                            className={errors.ifsc && touched.ifsc ? "border-red-500" : ""}
                                                        />
                                                    </FieldWrappers>
                                                    {errors.ifsc && touched.ifsc && (
                                                        <ErrorText>{errors.ifsc}</ErrorText>
                                                    )}
                                                    {/* <div
                                                        className="mt-2 flex items-center justify-between rounded-md border border-primary-color/10 bg-primary-color/10 px-3 py-2"
                                                    >
                                                        <span className="text-xs text-primary-color">
                                                            Verify account holder name before transfer
                                                        </span>

                                                        <button
                                                            disabled={
                                                                !values.accountNumber ||
                                                                !values.ifsc ||
                                                                verifyAccountLoading
                                                            }
                                                            type="button"
                                                            className="text-sm font-semibold text-primary-color disabled:text-gray-400 disabled:cursor-not-allowed"
                                                            onClick={() => {
                                                                verifyBankAccountMutate({
                                                                    accountNumber: values.accountNumber,
                                                                    ifsc: values.ifsc,
                                                                });
                                                            }}
                                                        >
                                                            {verifyAccountLoading ? 'Verifying' : 'Verify'}
                                                        </button>
                                                    </div>
                                                    {verifyErrorMsg && (
                                                        <div
                                                            className="mt-2 flex items-center justify-between rounded-md border border-rose-50 bg-rose-50 px-3 py-2"
                                                        >
                                                            <span className="text-xs text-rose-600">
                                                                {verifyErrorMsg}
                                                            </span>
                                                        </div>
                                                    )} */}
                                                    <VerifyBankAccount
                                                        loading={verifyAccountLoading}
                                                        verified={isAccountVerified}
                                                        error={verifyErrorMsg}
                                                        disabled={!values.accountNumber || !values.ifsc}
                                                        onVerify={() =>
                                                            verifyBankAccount({
                                                                accountNumber: values.accountNumber,
                                                                ifsc: values.ifsc,
                                                            })
                                                        }
                                                    />
                                                </InputGroup>
                                            </>
                                        )}

                                        {/* Common Fields for both tabs */}
                                        <InputGroup>
                                            <Label htmlFor="method">Transfer Method *</Label>
                                            <FieldWrappers onClick={() => setIsMethodModalOpen(true)}>
                                                <Field
                                                    type="text"
                                                    name="methodDisplay"
                                                    id="methodDisplay"
                                                    autoComplete="off"
                                                    readOnly
                                                    value={getCurrentMethodLabel(values.method)}
                                                    className="w-full border-none outline-none bg-transparent cursor-pointer"
                                                    placeholder="Select transfer method"
                                                />
                                                <MdEdit className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors duration-200 flex-shrink-0 mr-2" />
                                            </FieldWrappers>
                                            {errors.method && touched.method && (
                                                <ErrorText>{errors.method}</ErrorText>
                                            )}
                                        </InputGroup>
                                        {/* <div
                                            className={`rounded-lg px-4 py-3 border ${Number(availableAmount) < 100 ? "bg-red-50 border-red-100" : "bg-green-50 border-green-100"}`}
                                        >
                                            <div className="flex items-center justify-between">
                                                <p className={`text-sm font-medium ${availableAmount < 100 ? "text-red-700" : "text-green-700"}`}>
                                                    Available Balance
                                                </p>

                                                <p className={`text-lg font-semibold ${availableAmount < 100 ? "text-red-800" : "text-green-800"}`}>
                                                    ₹{Number(availableAmount || 0).toLocaleString("en-IN")}
                                                </p>
                                            </div>

                                            <p className="text-xs text-green-600 mt-1">
                                                Maximum transfer limit is {Number(availableAmount) > 500000 ? '₹5,00,000' : Number(availableAmount)}
                                            </p>

                                            {values.method === 3 && (
                                                <p className="text-xs text-orange-600 mt-1">
                                                    RTGS minimum amount is ₹2,00,000
                                                </p>
                                            )}
                                        </div> */}
                                        <InputGroup>
                                            {/* <Label htmlFor="amount">Amount *</Label> */}
                                            <div className="flex justify-between items-center mb-1">
                                                <Label htmlFor="amount">Amount *</Label>

                                                <span className="text-xs font-medium text-green-600">
                                                    Balance ₹{Number(availableAmount).toLocaleString("en-IN")}
                                                </span>
                                            </div>
                                            <FieldWrappers>
                                                <RupeeIcon />
                                                <Field
                                                    type="text"
                                                    name="amount"
                                                    id="amount"
                                                    autoComplete="off"
                                                    className={`pl-6 ${errors.amount && touched.amount ? "border-red-500" : ""}`}
                                                    placeholder="Enter amount"
                                                    min="1"
                                                    max="1000000"
                                                    step="1"
                                                />
                                            </FieldWrappers>
                                            {errors.amount && touched.amount && (
                                                <ErrorText>{errors.amount}</ErrorText>
                                            )}
                                        </InputGroup>

                                        <div className="flex items-start justify-between rounded-lg border border-gray-200 px-4 py-3">
                                            <div className="pr-4">
                                                <p className="text-sm font-medium text-gray-500">
                                                    Deduct Transaction Charges from Recipient
                                                </p>

                                                {/* <p className="mt-1 text-xs text-gray-500">
                                                    Vendor will receive amount after deducting transfer charges and taxes.
                                                </p> */}
                                            </div>

                                            <Field
                                                type="checkbox"
                                                name="deductChargesFromVendor"
                                                checked={values.deductChargesFromVendor}
                                                onChange={(e) =>
                                                    setFieldValue(
                                                        "deductChargesFromVendor",
                                                        e.target.checked
                                                    )
                                                }
                                                className="h-5 w-5 accent-primary-color"
                                            />
                                        </div>

                                        <InputGroup>
                                            <Label htmlFor="category">Category *</Label>
                                            <CategoryCard type="button" selectedCategory={selectedCategory} title="Category" onClick={() => setShowCategoryModal(true)} />
                                            {errors.category && touched.category && (
                                                <ErrorText>{errors.category}</ErrorText>
                                            )}
                                        </InputGroup>

                                        <InputGroup>
                                            <Label htmlFor="remarks">Remarks</Label>
                                            <Textarea
                                                id="remarks"
                                                name="remarks"
                                                placeholder="Add any additional notes here..."
                                                value={values.remarks}
                                                onChange={(e) => handleRemarksChange(e, setFieldValue)}
                                                onBlur={handleBlur}
                                                maxLength={500}
                                            />
                                            <CharacterCount className={values.remarks?.length > 450 ? "text-orange-500" : "text-gray-400"}>
                                                {values.remarks?.length || 0}/500
                                            </CharacterCount>
                                            {errors.remarks && touched.remarks && (
                                                <ErrorText>{errors.remarks}</ErrorText>
                                            )}
                                        </InputGroup>
                                    </Wrapper>
                                </ScrollableContent>

                                <ActionSection>
                                    <SideCancelBtn type="button" onClick={handleClose}>
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn type="submit" disabled={isSubmitting || addTransferAccountLoading}>
                                        {isSubmitting || addTransferAccountLoading ? "Submitting..." : "Submit"}
                                    </SubmitBtn>
                                </ActionSection>

                                {/* Transfer Method Selection Modal */}
                                <SelectOptionModal
                                    isOpen={isMethodModalOpen}
                                    onClose={() => setIsMethodModalOpen(false)}
                                    title="Select Transfer Method"
                                    options={transferMethodOptions}
                                    selectedValue={values.method}
                                    onSelect={handleMethodSelect}
                                    searchPlaceholder="Search transfer methods..."
                                />

                                {/* Beneficiary Selection Modal */}
                                <SelectItemModal
                                    isOpen={sBeneficaryModalOpen}
                                    onClose={() => setIsBeneficaryModalOpen(false)}
                                    onSelect={handleBeneficiarySelect}
                                    options={beneficiary || []}
                                    selectedItem={selectedBeneficary}
                                    title="Select Beneficiary"
                                    searchPlaceholder="Search beneficiary..."
                                    idKey="id"
                                    nameKey="name"
                                    descriptionKeys={["mobile"]}
                                    emptyMessage="No beneficiary available"
                                    noResultsMessage="No beneficiary found"
                                />

                                <SelectCategoryModal
                                    isOpen={showCategoryModal}
                                    onClose={() => setShowCategoryModal(false)}
                                    onSelect={handleCategorySave}
                                    categories={categories}
                                    selectedCategory={selectedCategory}
                                />
                            </Form>
                        );
                    }}

                </Formik>
                <ConfirmModal
                    isOpen={showConfirmTransferModal}
                    setOpenModel={setShowConfirmTransferModal}
                    title="Confirm Transfer"
                    message={
                        pendingPayload?.deductChargesFromVendor
                            ? `You are about to transfer ₹${Number(
                                pendingPayload?.amount || 0
                            ).toLocaleString("en-IN")}. Transfer charges will be deducted from the vendor. Do you want to continue?`
                            : `You are about to transfer ₹${Number(
                                pendingPayload?.amount || 0
                            ).toLocaleString("en-IN")}. Do you want to continue?`
                    }
                    onClose={() => {
                        setShowConfirmTransferModal(false);
                        setPendingPayload(null);
                    }}
                    onConfirm={() => {
                        addTransferAccountMutate(pendingPayload);
                    }}
                    loading={addTransferAccountLoading}
                    confirmBtnText="Confirm Transfer"
                    confirmBtnClassName="bg-primary-color text-white border border-primary-color hover:opacity-90"
                />
            </div>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded-md pl-2 py-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y break-words overflow-hidden`;
const ErrorText = tw.div`text-red-500 text-sm ml-0.5`;
const CharacterCount = tw.div`text-xs mt-1 text-right`;
const Text = tw.p`text-gray-500 text-xs font-normal `;

const SimpleInput = tw.input`
    w-full 
    border 
    border-gray-300 
    rounded-md 
    px-3 
    py-2 
    focus:ring-1 
    focus:ring-sky-600 
    focus:border-sky-600 
    focus:outline-none 
    duration-200
`;

export default AddTransferDetail;